/**
 * The warm-up day that a person sees. The API sends `day` 0-based (0 on the connect day), but the
 * copy says "Day 1 of 21" on the connect day. The value stops at `totalDays`.
 */
export function warmupDisplayDay(warmup: { day: number; totalDays: number }): number {
  return Math.min(warmup.day + 1, warmup.totalDays);
}
